import { api } from "./api";
import { paramsReducer } from "./utils";
import type { User, ApiResponse, Role, UserWrite } from "@/types/api/types.ts";

type Params = {
  search?: string;
};

export type UserUpdate = { uuid: string } & UserWrite;

export const ExampleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<ApiResponse<User>, Params>({
      query: (params) => ({
        url: paramsReducer(`users`, params),
        headers: {
          Accept: "application/ld+json",
        },
      }),
      providesTags: ["Users"],
    }),
    addUser: builder.mutation({
      query: (body: UserWrite) => {
        return {
          url: "users",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Users"],
    }),
    updateUser: builder.mutation<User, UserUpdate>({
      query: ({ uuid, ...body }) => {
        return {
          url: `users/${uuid}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Users"],
    }),
    getRoles: builder.query<ApiResponse<Role>, string>({
      query: () => ({
        url: "user_roles",
        headers: {
          Accept: "application/ld+json",
        },
      }),
      providesTags: ["Roles"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useGetRolesQuery,
  useAddUserMutation,
  useUpdateUserMutation,
} = ExampleApi;
